import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";
export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Web Developer", "Backend Developer", "Student"];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta)
        return () => { clearInterval(ticker) };
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);
        if (isDeleting) {
            setDelta(prevDelta => prevDelta / 2)
        }
        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if (isDeleting && updatedText == '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    }
    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                        <span className="tagline">
                            Welcome to my Portfolio
                        </span>
                        <h1>{'Hi, It`s me Saugat,'} <br /><span className="wrap"> A {text}</span> </h1>
                        <p>As a seasoned Full Stack Developer with over two years of dedicated experience in Laravel development, I've contributed significantly to diverse projects, including the creation of robust e-commerce platforms. During my tenure as a Laravel backend developer within a company, I actively engaged in managing projects on cPanel hosting, honing my skills in navigating hosting environments efficiently.
                            Presently, I'm enthusiastically working on a groundbreaking web application using React JS, Vue JS and Laravel. This application aims to showcase comprehensive company details while laying the groundwork for implementing cutting-edge text recognition processes. This innovation will streamline the application process for individuals aspiring to work abroad by autonomously generating necessary documents, revolutionizing the experience for prospective employees seeking opportunities abroad.</p>
                        <button onClick={() => console.log('connect')}>Lets Connect <ArrowRightCircle size={25}></ArrowRightCircle> </button>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <img src={headerImg} alt="Header Img" />
                    </Col>

                </Row>
            </Container>
        </section>
    )
}